import {
	BifrostBackendApi,
	BifrostBackendNestApi,
	BifrostBackendViaCdnApiV2
} from "../gateways/BifrostBackendApi";
import { store } from "../store";
import appConfig from "../appconfig";

function getInsertUpdateDeleteApi() {
	const useNestOrderPaymentFlow = store.getters.featureToggles?.useNestOrderPaymentFlow;
	return useNestOrderPaymentFlow ? BifrostBackendNestApi : BifrostBackendApi;
}

const PriceRulesProvider = {
	async findAll(queryData = {}, useApiCdnCaching) {
		const res = await (useApiCdnCaching
			? BifrostBackendViaCdnApiV2
			: BifrostBackendNestApi
		).get("/price-rules", {
			params: {
				$limit: "10000",
				...queryData,
				tenantId: appConfig.tenantId
			}
		});

		return res;
	},

	async insert({
		name,
		orderingDatePattern,
		weekDay,
		shopPattern,
		productPattern,
		discountValue,
		discountType,
		voucherPattern,
		productSpecific,
		customerPattern,
		options,
		dateRule
	}, jwtToken) {
		const api = getInsertUpdateDeleteApi();
		return api.post(
			`/intadm/priceRules`,
			{
				tenantId: appConfig.tenantId,
				name,
				orderingDatePattern,
				weekDay,
				shopPattern,
				productPattern,
				discountType,
				discountValue,
				voucherPattern,
				productSpecific,
				customerPattern,
				options,
				dateRule
			},
			{
				headers: {
					Authorization: jwtToken
				}
			}
		);
	},

	async delete(id, jwtToken) {
		const api = getInsertUpdateDeleteApi();
		return api.delete(`/intadm/priceRules/${id}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async get(id, jwtToken) {
		const api = getInsertUpdateDeleteApi();
		return api.get(`/intadm/priceRules/${id}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async update(id, data, jwtToken) {
		const api = getInsertUpdateDeleteApi();
		return api.put(
			`/intadm/priceRules/${id}?tenantId=${data.tenantId}`,
			data,
			{
				headers: {
					Authorization: jwtToken
				}
			}
		);
	}
};

export default Object.freeze(PriceRulesProvider);
